export const DPVALE_FORM_URL = 'https://cl.s13.exct.net/DEManager.aspx';
export const DPVALE_FORM_CLIENT_ID = '546000670';
export const DPVALE_FORM_DE_EXTERNAL_KEY = '4B39959D-1B30-42EE-90EB-241147AEBB2A';
export const DPVALE_FORM_SUCCESS_URL = 'https://www.dportenis.mx/success';
export const DPVALE_FORM_ERROR_URL = 'https://www.dportenis.mx/failed';
export const DPVALE_FORM_ACTION = 'add/update';
export const DPVALE_FORM_RETURN_XML = '0';
